import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'sume-checkbox',
    templateUrl: './checkbox.component.html',
})
export class CheckboxComponent {
    @Input() label: string;
    @Input() controlName: string;
    @Input() formGroup: FormGroup;
    @Input() labelOnTop = true; // label em cima ou do lado

    get isInvalid(): boolean {
        const control = this.formGroup?.get(this.controlName);
        return !!(control && control.invalid && control.touched);
    }
}
